import { items } from './Items'

export const EQUIP_SLOTS = {
  head: 16,
  chest: 17,
  legs: 18,
  rItem: 19,
  back: 20,
  boots: 21,
}

const EQUIP_SLOT_SET = new Set(Object.values(EQUIP_SLOTS))

export const HOT_SLOTS = 4 // number of hotbar slots (indices 0 to HOT_SLOTS-1)
export const INVENTORY_SIZE = 22 // total slot count: 4 hotbar + 12 backpack + 6 equip

export function isEquipSlot(idx) {
  return EQUIP_SLOT_SET.has(idx)
}

export function isHotSlot(idx) {
  return idx >= 0 && idx < HOT_SLOTS
}

export function isBackpackSlot(idx) {
  return !isEquipSlot(idx) && !isHotSlot(idx)
}

export const InventoryTypes = {
  equipment: {
    accepts(slotIdx, item) {
      if (slotIdx === EQUIP_SLOTS.head) return item?.equip?.slot === 'head'
      if (slotIdx === EQUIP_SLOTS.chest) return item?.equip?.slot === 'chest'
      if (slotIdx === EQUIP_SLOTS.legs) return item?.equip?.slot === 'legs'
      if (slotIdx === EQUIP_SLOTS.rItem) return item?.equip?.slot === 'rItem'
      if (slotIdx === EQUIP_SLOTS.back) return item?.equip?.slot === 'back'
      if (slotIdx === EQUIP_SLOTS.boots) return item?.equip?.slot === 'boots'
      // hotbar slots only accept consumables (for now)
      if (isHotSlot(slotIdx)) return !!item?.consumable
      return true
    },
  },
}

export function moveItems({ srcInventory, destInventory, srcIdx, destIdx }) {
  const srcSlots = srcInventory?.slots
  const destSlots = destInventory?.slots
  const src = srcSlots?.[srcIdx]
  const dest = destSlots?.[destIdx]
  const srcItem = items[src?.id]

  if (!srcSlots || !destSlots) return
  if (!acceptsItem(destInventory?.type, destIdx, srcItem)) return
  if (!src || src === dest) return
  const destItem = items[dest?.id]
  if (dest && !acceptsItem(srcInventory?.type, srcIdx, destItem)) return

  if (!dest) {
    srcSlots[srcIdx] = null
    destSlots[destIdx] = src
    return
  }
  if (dest.id !== src.id) {
    srcSlots[srcIdx] = dest
    destSlots[destIdx] = src
    return
  }

  const max = items[dest.id].max ?? 1
  const space = Math.max(0, max - dest.qty)
  if (space === 0) {
    srcSlots[srcIdx] = dest
    destSlots[destIdx] = src
    return
  }

  const taking = Math.min(src.qty, space)
  dest.qty += taking
  src.qty -= taking
  if (src.qty <= 0) srcSlots[srcIdx] = null
}

export function acceptsItem(type, slotIdx, item) {
  const def = InventoryTypes[type]
  if (!def?.accepts) return true
  return def.accepts(slotIdx, item)
}
